import { useQuery } from "@apollo/client"
import React, { useEffect } from "react"
import { getOpportunities } from "../../../api/suppliers"
import { GroupModel } from "../../../models/organisation/GroupModel"
import { Suppliers } from "../../../models/organisation/Suppliers"
import { SupplierOpportunity } from "../../../models/supplier/SupplierOpportunity"
import { UserTokenModel } from "../../../models/UserTokenModel"
import { useSelector } from "react-redux"
import { useAppContext } from "../../../contexts/AppContext"

type Props = {
    onResult: (result: { opp: SupplierOpportunity[]; suppliers: Suppliers[] }) => void
    setLoading: any
    reload: number
}

export const SupplierData = ({ onResult, setLoading, reload }: Props) => {

    const { millSelected } = useAppContext()

    const token = useSelector((state: any) => state.token.value)

    const { data, loading, error, refetch } = useQuery(getOpportunities, {
        fetchPolicy: 'no-cache',
        skip: !token,
        variables: {
            orgId: millSelected.id
        },
        onCompleted(data) {
            const opp = data.opportunities.map(o => SupplierOpportunity.build(o))
            const map = new Map<number, Suppliers>()
            const groups = GroupModel.buildGroups(data.groups)
            groups.forEach(g => {
                if (map.has(g.org.id)) {
                    const v: Suppliers = map.get(g.org.id)
                    v.groups = [...v.groups, g]
                    map.set(g.org.id, v)
                } else {
                    map.set(g.org.id, Suppliers.build({ mill: g.org, groups: [g] }))
                }
            });
            onResult({ opp: opp, suppliers: [...map.values()] })
        },
    })

    useEffect(() => {
        refetch()
    }, [reload])

    useEffect(() => {
        setLoading(loading)
    }, [loading])

    return <></>
}